<template>
    <div>
        <el-tree :data="menuItems" node-key="id" default-expand-all @node-click="handleNodeClick">
        </el-tree>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isCollapse: false, // 控制菜单折叠（可选，可根据需求添加折叠按钮）
            menuItems: [
                {
                    id: 1,
                    label: '注册账号',
                    name: 'RegisterAccount',
                },
                {
                    id: 2,
                    label: '登录系统',
                    name: 'LoginAccount',
                },
                {
                    id: 3,
                    label: '积分充值',
                    name: 'PointsTopUp',
                },
                // {
                //     id: 4,
                //     label: '专利方案挖掘',
                //     name: 'PatentPlanMining',
                //     // children: [
                //     //     {
                //     //         label: '使用流程',
                //     //         children: [
                //     //             {
                //     //                 id: 1,
                //     //                 label: '步骤一：进入模块',
                //     //             },
                //     //             {
                //     //                 id: 2,
                //     //                 label: '步骤二：输入需求',
                //     //             },
                //     //             {
                //     //                 id: 3,
                //     //                 label: '步骤三：AI推演与交底书生成',
                //     //             },
                //     //             {
                //     //                 id: 4,
                //     //                 label: '步骤四：查看与下载',
                //     //             }
                //     //         ]
                //     //     },
                //     // ]
                // },

            ],
        }
    },
    methods: {
        handleNodeClick(event) {
            this.$emit('menuClick', event)
        }
    }

}
</script>

<style scoped>
.sidebar-menu {
    width: 200px;
    /* 导航栏宽度 */
    min-height: 100vh;
    background-color: #fff;
    border-right: 1px solid #e6e6e6;
}
</style>